import { useEffect, useState } from 'react';
import { WbText, WbToggle } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import _notification from '../../../Utils/Vimdt/notification';
import './VimdtSwitch.scss';

function VimdtSwitch({
	label,
	onBtn,
	offBtn,
	defaultValue = false,
	val,
	getValue,
	disabled = false,
	onChange,
	status = ' ',
	className,
}) {
	const [value, setValue] = useState(defaultValue);
	const [key, setKey] = useState();
	const { t } = useTranslation();

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	const openNotification = (checked) => {
		setKey(
			_notification({
				title: label,
				message: `${t('vimdt.notification.switched')} ${checked ? status[1] : status[0]}`,
				duration: 5,
				key,
				onClose: () => setKey(undefined),
			})
		);
	};

	const handleChange = (event) => {
		if (onChange) {
			onChange(event);
			return;
		}
		const checked = event.detail.checked;
		setValue(checked);
		if (getValue) getValue(checked);
		openNotification(checked);
	};

	return (
		<div className={`vimdt-switch ${className || ''}`}>
			<WbText className="vimdt-switch__label" size="s" data-testid="label">
				{label}
			</WbText>
			<div className="vimdt-switch__control">
				<WbText size="s" data-testid="onLabel">
					{onBtn}
				</WbText>
				<WbToggle
					checked={val ?? value}
					disabled={disabled || undefined}
					onWbchange={handleChange}
					data-testid="toggle"
				/>
				<WbText size="s" data-testid="offLabel">
					{offBtn}
				</WbText>
			</div>
		</div>
	);
}

export default VimdtSwitch;
